module.exports = "/_next/static/images/mobilelocation-line-2c4c6268ec6a691483d3b13dbd6b02a2.svg";